import React from "react";
import "./Css/RefundPolicy.css";

const RefundPolicy = () => {
  return (
    <div className="refund-page">
      <div className="refund-container">

        <h1 className="refund-title">Refund Policy</h1>

        <p>
          Thank you for purchasing our software products and services.
        </p>

        <p>
          As our products are digital software solutions, we do not offer refunds 
          once the software has been activated, downloaded, or accessed.
        </p>

        <h2>License & Subscription:</h2>
        <ul>
          <li>All software licenses are non-transferable.</li>
          <li>Subscription fees (if applicable) are billed as per the selected plan.</li>
          <li>Renewal payments are non-refundable once processed.</li>
        </ul>

        <h2>Cancellation Policy:</h2>
        <ul>
          <li>You may cancel your subscription at any time.</li>
          <li>Cancellation will stop future billing.</li>
          <li>No refunds will be provided for the current billing cycle.</li>
        </ul>

        <h2>Technical Issues:</h2>
        <ul>
          <li>If you experience technical problems, please contact our support team.</li>
          <li>We will make reasonable efforts to resolve issues promptly.</li>
        </ul>

        <h2>Exceptions:</h2>
        <ul>
          <li>Refunds may be considered only in cases of duplicate payments or billing errors.</li>
          <li>Approved refunds (if any) will be processed within 7–10 working days.</li>
        </ul>

        <div className="refund-contact">
          <h3>For support or billing queries:</h3>
          <p>📧 akessoftware@gmail.com</p>
        </div>

      </div>
    </div>
  );
};

export default RefundPolicy;